import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDataProvider } from "src/system/useDataProvider.ts";
import { useResourceQueries } from "src/framework/useResourceQueries.ts";

export const useCloneToLocale = ({
  resource,
  lang,
  id,
}: {
  resource: string;
  lang: string;
  id: string;
}) => {
  const dataProvider = useDataProvider();
  const queryClient = useQueryClient();
  const queries = useResourceQueries();
  return useMutation({
    mutationKey: [resource, "clone", id],
    mutationFn: ({ locale }: { locale: string }) => {
      return dataProvider.cloneToLocale({
        resource: resource,
        from_locale: lang,
        to_locale: locale,
        id: id,
      });
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: queries.detail({
          id: id!,
          resource,
        }),
        type: "all",
        refetchType: "none",
      });
    },
  });
};
